export default "__VITE_ASSET__b811a692__"